import styled from 'styled-components';

export const ImagePuffContainer = styled.div``;

export const ImagePuffContent = styled.div`
	background-color: ${props => props.theme.colors.white};
	padding: ${props => props.theme.spacing.space4}rem;
`;
